/** @format */

const template = `
<ng-form name="{{::ctrl.name}}">
  <div class="row">
    <div class="col-md-12">
      <ng-transclude></ng-transclude>

      <div class="grouping-panel-content">
        <div
          class="box focusable-element"
          ng-class="{ 'has-error': ctrl.form[ctrl.name].$invalid, 'disabled': ctrl.disableEditing}"
          medium-editor
          ng-model-options="{ allowInvalid: true }"
          ng-change="ctrl.onChangeFunc()"
          ng-model="ctrl.ngModel.$viewValue"
          bind-options="ctrl.mediumEditorOptions"
          ng-minlength="ctrl.realMinLength"
          ng-maxlength="ctrl.maxLength"
          ng-required="!ctrl.form[ctrl.name].$pristine && ctrl.ngModel.$error.requireAnswer"
          ng-attr-contenteditable="{{!ctrl.disableEditing}}"
          placeholder="{{ ctrl.placeholder | translate }}">
        </div>
        <div class="markup-indicator">
          <sis-tooltip
            tooltip-text="{{'SIS_COMPONENTS.STRING.LOCALIZED_MARKUP_STRING_EDITOR.INDICATOR_TOOLTIP' | translate}}"
            tooltip-class="tooltip-wide"
            [tooltip-block-element]="true">
            <sis-icon icon="editor" class="sis-tooltip-trigger-content" color="white"></sis-icon>
          </sis-tooltip>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <ul
        ng-if="!ctrl.hideErrors && ctrl.form[ctrl.name].$invalid"
        class="error-list"
        ng-messages="ctrl.form[ctrl.name].$error"
        ng-messages-multiple="true"
        role="alert">
        <li ng-message="minlength" translate translate-value-langname="{{ ctrl.errors('minlength') }}"
          >SIS_COMPONENTS.STRING.MARKUP_STRING_EDITOR.TOO_SHORT</li
        >
        <li ng-message="maxlength" translate translate-value-langname="{{ ctrl.errors('maxlength') }}"
          >SIS_COMPONENTS.STRING.MARKUP_STRING_EDITOR.TOO_LONG</li
        >
      </ul>
    </div>
  </div>
</ng-form>
`;
export default template;
